<template>
  <div class="footer-wrapper">
    <div class="box-container">
      <div class="box-title">联系我们</div>
      <div class="box-content">
        <div class="box-item">
          联系地址：杭州市滨江区联慧街6号矽力杰大厦
        </div>
        <div class="box-item">
          联系方式：0571-81968150
        </div>
      </div>
    </div>
    <div class="box-container">
      <div class="box-title">主要产品</div>
      <div class="box-content width-fixed">
        <div class="box-item" @click="handleRoute(item.path, item.params)" v-for="(item, index) in productData" :key="index">
          {{item.name}}
        </div>
      </div>
    </div>
    <div class="box-bottom">
      <a>Copyright 2020 版权所有：浙江禾悦智能科技有限公司</a>
      <a style="display:inline-block;text-decoration:none;height:15px;line-height:15px;margin: 0px 10px">
        <img src="../../assets/images/policeLogo.png" style="float:left;"/>
        <p style="float:left;height:19.2px;line-height:19.2px;margin: 0px 0px 0px 5px; color:#fff;">浙公网安备 33010802011167号</p>
      </a>
      <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank" class="box-bottom-beian">浙ICP备18052284号-1</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footer',
  data () {
    return {
      productData: [
        {name: '统一支付云平台', path: '/product', params: {type: 'pay'}},
        {name: '统一对账云平台', path: '/product1', params: {type: 'dz'}},
        {name: '分诊排队叫号系统', path: '/product2', params: {type: 'hqms'}},
        {name: '智慧场所云管理平台', path: '/product3'},
        {name: '智慧村社管理平台', path: '/product4'},
        {name: '智慧医疗自助服务系统', path: '/product5'},
        {name: '电子功德箱', path: ''},
        {name: '自助服务终端', path: ''},
        {name: '智慧民生自助服务系统软件', path: ''},
        {name: '住房线上贷系统', path: ''}
      ]
    }
  },
  mounted () {},
  methods: {
    handleRoute (path, params = {}) {
      this.$router.push({
        path,
        params
      })
    }
  },
  watch: {}
}
</script>

<style scoped lang="less">
  @import "../../assets/css/variable";
  .box-bottom {
    height: 42px;
    text-align: center;
    font-family: Microsoft YaHei;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    margin-top: 50px;
}
.box-bottom-beian {
  text-decoration: none;
  color: #fff;
}
  .footer-wrapper {
    max-width: @width-max;
    margin: 0 auto;
    color: @text-color-inverse;
    display: flex;
    flex-direction: row;
    flex-flow: wrap;
    justify-content: space-between;
  }
  .box-container{
    margin: @spacing-col-lg @spacing-row-lg;
    .box-title {
      font-family: SourceHanSansCN-Medium;
      font-size: 18px;
      font-weight: bold;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #ffffff;
      margin-bottom: 20px;
    }
    .box-content {
      display: flex;
      flex-direction: row;
      flex-flow: wrap;
      &.width-fixed {
        width: 360px;
        .box-item {
          width: 180px;
        }
      }
      .box-item {
        cursor: pointer;
        margin-bottom: 10px;
        height: 26px;
        line-height: 24px;
        width: 100%;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue